import { Theme } from '@material-ui/core/styles';

export const clientAccentOverrides = (theme: Theme) => ({
  '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.client.primary.main,
  },
  '& .MuiFormLabel-root.Mui-focused': {
    color: theme.palette.client.primary.main,
  },
  '& .MuiLink-root': {
    color: theme.palette.client.primary.main,
  },
});
